// Use this when assumptions about user state availability are wrong
export const hardRedirectToLoginPage = (reason: unknown): never => {
  localStorage.setItem('@geomoby/hardResetReason', JSON.stringify(reason));
  sessionStorage.clear();
  location.assign('/');
  throw new Error(
    'This user is requesting their bearer, but they do not have one. Re-locating to sign in page.',
  );
};
